
import  silvergladeslegacy  from "../../../../public/projects/silverglades/images/silvergladeslegacy.webp";
import logo from "../../../../public/projects/silverglades/images/logo/logo.png"

export const developersSilverGlades = {
  name: `Silverglades Properties in Gurugram`,
  properties: [
    {
      name: "Silverglades - 59",
      image: silvergladeslegacy,
      price: "On Request",
      location: "Sector 59",
      state:"Gurugram",
      projectlocation:"Golf Course Extention Road",
      developer:"Silverglades",
      bed: "1 - 3 BHK ",
      size: "....",
      url: ``,
      form:{
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
      }
    },
  ],
};


export const Headers={
  logo:logo,
  data:
    {
      experience:`1988`,
      projects:`118`,
      ongoingprojects:`18`
    },
  about:`Silverglades is one of India's leading boutique developers, specializing in
   Residential Housing, Commercial, Township Projects and Golf-based leisure developments.
    Mr. Pradeep Jain of Silverglades in collaboration with ITC Limited developed The Laburnum and the
     Classic Golf Resort in Gurgaon. These projects were followed by The IVY, a Housing Project in Gurgaon
      and India’s first gated golf community, Tarudhan Valley Golf Resort, a mere kilometre away from the Classic
       Golf Resort. The Pioneering efforts of Silverglades have resulted in some of the most iconic landmarks in and 
       around Delhi NCR.`
}